import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VCalendar from 'v-calendar'

import 'v-calendar/dist/style.css'


createApp(App).use(store).use(router).use(VCalendar, {}).use(Toast,{
  transition: 'Vue-Toastification__bounce',
  maxToasts: 5,
  newestOnTop: true,
  position: 'top-right', // or top-center
  timeout: 3000
}).mount('#app')
